import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import $ from 'jquery';
import QRCode from 'qrcodejs2';
// import { DragControls } from 'three/examples/jsm/controls/DragControls';
var qrcode;
//3d文物参数 √
var tex, scale, PLight, Alight, highlight, photonear, photofar, ambientcolor, pointColor, normalPath, parallelLight, normalMapStrength, onOtherProgress;
var angleX = [];
var angleY = [];
var angleZ = [];
var axisX = [];
var axisY = [];
var axisZ = [];
var tex = [];
var model = [];
var modelName = [];
var mtl = [];
var index2 = [];
var index = [];
var mtlUrl = [];
var mtlName = [];
var normalPath = [];
var stageUrl = process.env.VUE_APP_IMG_URL;
var camera,
  scene,
  renderer,
  controls,
  ob,
  fbx = 0,
  onProgress,
  attributeModels,
  objectModel,
  group,
  hemiLight,
  ambientLight,
  directionalLight,
  pointLight,
  pointLight1,
  pointLight2,
  pointLight4,
  manager,
  progressNums = [],
  orbitControls,
  objects = [];
export default {
  name: '3d',
  meta: {
    title: '文物综合展示系统'
  },
  data() {
    return {
      singleform: {
        deptId: '',
        formId: ''
      },
      detailData: {
        deptId: '',
        formId: ''
      },
      detail: {},
      swiperEl: '',
      showModels: [false, false, false],
      list: [],
      listPage: 1,
      listTotal: 0,
      detailCode: '',
      activeIndex: -1,
      activeDetail: {},
      swiperElImg: '',
      swiperElNav: '',
      options: {
        source: '',
        width: 480,
        height: 327,
        frames: 34,
        framesX: 6,
        sense: -1
      },
      qrCodeUseTime: 5,
      config: {},
      columns: [],
      columnName: '',
      showBigErCode: false,
      activeName: '2',
      space: {
        attributeModels: []
      },
      light: {},
      others: {},
      detailId: '',
      showDebug: false,
      formId: '',
      translateX: 0,
      translateY: 0
    };
  },
  methods: {
    test() {
      console.log(group.position.z);
    },
    // 鼠标摁下
    mouseupFun(e) {
      if (e.button != 2) return;
      this.translateX = e.clientX;
      this.translateY = e.clientY;
    },
    canvasMouse() {
      let oDiv = document.getElementsByTagName('canvas')[0];
      console.log(oDiv);
      oDiv.onmousedown = e => {
        // 算出鼠标相对元素的位置
        let disX = e.clientX - group.position.x;
        let disY = e.clientY - group.position.y;
        oDiv.onmousemove = e => {
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;
          let top = -(e.clientY - disY);

          // oDiv.style.left = left + 'px';
          // oDiv.style.top = top + 'px';
          console.log(e, 11);
          if (e.buttons == 2) {
            console.log(left, top);
            group.position.set(left, top, group.position.z);
          }
        };
        oDiv.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },
    // 点击左侧三个按钮
    showModel(index) {
      this.showModels = this.showModels.map((item, i) => {
        i == index ? item = !item : item = false;
        return item;
      });
      if (index == 2 && this.showModels[2]) {
        this.$refs.voice.play();
      }
      if (index == 2 && !this.showModels[2]) {
        this.$refs.voice.pause();
      }
    },
    //获取栏目列表
    getColumn() {
      let query = {
        fid: this.$route.query.fid,
        formId: 112712,
        page: this.listPage,
        limit: 50
      };
      this.$api.singleformList(query).then(res => {
        this.setColumnData(res.data);
      });
    },
    toColumn(item, index) {
      this.swiperElNav.slideTo(index);
      this.columnName = item == '全部' ? '' : item;
      this.listPage = 1;
      if (this.detail.type == '3D') {
        this.clearScene('changeColumn');
      }
      this.getList('changeColumn');
    },
    //栏目信息解析
    setColumnData(data) {
      let list = data.map(item => {
        let nItem = {
          columnName: this.getListData(item.formData, 'name')
          // color: this.getListData(item.formData, 'color')
        };
        return nItem;
      });
      if (list.length > 1) {
        list.unshift({
          columnName: '全部'
        });
      }
      this.columns = list;
      this.$nextTick(() => {
        this.swiperElNav = new Swiper(this.$refs.swiperNav, {
          navigation: {
            nextEl: ".btnRight",
            prevEl: ".btnLeft"
          },
          direction: 'vertical',
          slidesPerView: 'auto',
          centeredSlides: true,
          touchMoveStopPropagation: true,
          runCallbacksOnInit: false,
          observer: true,
          //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,
          loop: false
        });
      });
    },
    getListData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values[0];
      if (!target) return '';
      return type ? process.env.NODE_ENV == 'development' ? stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '' : target.val;
    },
    // 通过文物编号获取当前文件信息及文物信息
    getDetailByCode(hideOther, isAdd) {
      // 当前文物的信息
      let a = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.detailCode
        }]],
        model: 0
      };
      this.singleform.deptId = this.$route.query.fid;
      this.singleform.formId = 112720;
      this.singleform.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.setData(res.dataList[0].formIdValueData, 'name', hideOther, isAdd);
      });
      // 文件信息
    },
    getFileData(isAdd) {
      let singleformFile = {
        deptId: this.singleform.deptId,
        formId: 113010
      };
      let b = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.detailCode
        }], [{
          alias: "type",
          compt: "selectbox",
          express: "match",
          id: 29,
          range: null,
          val: ['3D']
        }]],
        model: 0
      };
      singleformFile.searchStr = encodeURI(JSON.stringify(b));
      this.$api.singleadvanceSearch(singleformFile).then(res => {
        this.detailId = parseInt(res.dataList[0].id);
        this.formId = res.dataList[0].formId;
        this.setData(res.dataList[0].formIdValueData, isAdd);
      });
    },
    // 数据获取
    setData(data, type, hideOther, isAdd) {
      if (type == 'name') {
        this.detail.name = this.getValInFormData(data, 'antiqueName');
        this.detail.img = this.getValInFormData(data, 'thumbPath', 'img');
        this.detail.description = this.getValInFormData(data, 'description');
        this.detail.audio = this.getValInFormData(data, 'audio', 'objectId');
        this.detail.zhuanti = this.getValInFormData(data, 'mobileSpecial');
        hideOther ? this.list.push(this.detail) : '';
        return this.getFileData(isAdd);
      } else {
        this.detail.type = this.getValInFormData(data, 'type');
        this.detail.code = this.detailCode;
        if (type == 'addActiveItem') {
          let detail = JSON.parse(JSON.stringify(this.detail));
          this.list.unshift(detail);
        }
        if (this.detail.type == '图片') {
          this.detail.images = data['image'].groupValues[0].values[0].map(img => {
            return process.env.NODE_ENV == 'development' ? stageUrl + img.name : img.fileUrl ? img.fileUrl.replace('http:', 'https:') : '';
          });
          return this.initImage();
        }
        if (this.detail.type == '3D') {
          this.clearBeforeModel();
          this.$nextTick(() => {
            this.get3dData(data);
          });
          return;
        }
        this.init360(data);
      }
    },
    getAudioPath(path) {
      this.$api.getUrlByObjectId(path).then(res => {
        this.detail.audio = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
      });
    },
    reset() {
      this.$confirm('重置后将恢复初始值，请您确认是否需要重置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (let key in this.light) {
          key == 'envLight' ? this.light[key] = 1 : this.light[key] = 0.01;
        }
        this.space.attributeModels = this.space.attributeModels.map(item => {
          for (let key in item) {
            item[key] = 0;
          }
          return item;
        });
        this.space.modelCenter = '关闭';
        this.saveParams('reset');
      });
    },
    // 3d数据解析
    get3dData(data) {
      document.getElementById("bar_" + this.detail.code).innerHTML = '';
      document.getElementById("loadbar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.display = 'block';
      document.getElementById("bar_" + this.detail.code).style.width = '2%';
      let attribute3d = {
        highlight: this.getValInFormData(data, 'highLight'),
        zoomRatio: this.getValInFormData(data, 'zoom'),
        opacity: this.getValInFormData(data, 'transparency'),
        canvasColor: this.getValInFormData(data, 'color'),
        minDistance: this.getValInFormData(data, 'minDistance'),
        maxDistance: this.getValInFormData(data, 'maxDistance'),
        pointLight: this.getValInFormData(data, 'pointLight'),
        pointColor: this.getValInFormData(data, 'pointLightColor'),
        envLight: this.getValInFormData(data, 'environmentLight'),
        envColor: this.getValInFormData(data, 'environmentColor'),
        normalMapStrength: this.getValInFormData(data, 'normalMapStrength'),
        parallelLight: this.getValInFormData(data, 'parallelLight'),
        modelCenter: this.getValInFormData(data, 'modelCenter'),
        attributeModels: []
      };
      this.detail.attribute3d = attribute3d;
      attributeModels = attribute3d.attributeModels;
      photonear = parseFloat(attribute3d.minDistance); //远相机
      photofar = parseFloat(attribute3d.maxDistance); //近相机
      scale = parseFloat(attribute3d.zoomRatio); //缩放
      PLight = parseFloat(attribute3d.pointLight); //点光
      pointColor = attribute3d.pointColor; //点光颜色
      highlight = parseFloat(attribute3d.highlight); //半球光颜色、在场景之上，光照颜色从天空光线颜色颜色渐变到地面光线颜色
      Alight = parseFloat(attribute3d.envLight); //环境光
      ambientcolor = attribute3d.envColor; //环境光颜色
      parallelLight = parseFloat(attribute3d.parallelLight); //平行光（太阳光）
      normalMapStrength = parseFloat(attribute3d.normalMapStrength); //法线贴图强度
      if (process.env.NODE_ENV == 'development') {
        data[25].groupValues.map((item, index) => {
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            mtlFile: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            modelPath: data[25].groupValues[index].values[0][0] ? stageUrl + data[25].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? stageUrl + data[26].groupValues[index].values[0][0].name : '',
            chartlet: data[24].groupValues[index].values[0][0] ? stageUrl + data[24].groupValues[index].values[0][0].name : ''
          };
          attributeModels.push(itemData);
          if (attributeModels.length == data[25].groupValues.length) {
            this.$nextTick(() => {
              this.init3d();
              this.animate();
            });
          }
        });
      } else {
        let t_url = {};
        data[25].groupValues.map((item, index) => {
          let t_name = [];
          let itemData = {
            angleX: parseFloat(this.getValInFormData(data, 'angleX', '', index)),
            angleY: parseFloat(this.getValInFormData(data, 'angleY', '', index)),
            angleZ: parseFloat(this.getValInFormData(data, 'angleZ', '', index)),
            axisX: parseFloat(this.getValInFormData(data, 'axisX', '', index)),
            axisY: parseFloat(this.getValInFormData(data, 'axisY', '', index)),
            axisZ: parseFloat(this.getValInFormData(data, 'axisZ', '', index)),
            modelName: data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].name : '',
            mtlName: data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].name : '',
            normalPath: data[26].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[26].groupValues[index].values[0][0].objectId}.${data[26].groupValues[index].values[0][0].suffix}` : ''
          };
          let model1 = this.$api.getUrlByObjectId(data[23].groupValues[index].values[0][0] ? data[23].groupValues[index].values[0][0].objectId : '');
          let model2 = this.$api.getUrlByObjectId(data[25].groupValues[index].values[0][0] ? data[25].groupValues[index].values[0][0].objectId : '');
          let model3 = this.$api.getUrlByObjectId(data[24].groupValues[index].values[0][0] ? data[24].groupValues[index].values[0][0].objectId : '');
          let ts = data[24].groupValues[index].values[0];
          let modelAll = [model1, model2];
          ts.map(t => {
            let m = this.$api.getUrlByObjectId(t.objectId);
            modelAll.push(m);
            t_name.push(t.name);
          });
          itemData.chartlet = data[24].groupValues[index].values[0][0] ? `https://museum.chaoxing.com/star3/origin/${data[24].groupValues[index].values[0][0].objectId}.${data[24].groupValues[index].values[0][0].suffix}` : '';
          Promise.all(modelAll).then(res => {
            // mtl文件
            itemData.mtlFile = res[0].download ? res[0].download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/') : '';
            // 模型文件
            itemData.modelPath = res[1].download ? res[1].download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/') : '';
            // 贴图
            res.map((r, r_index) => {
              if (r_index > 1) {
                let t_name_str = t_name[r_index - 2].toLocaleLowerCase();
                t_url[t_name_str] = r.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
              }
            });
            if (t_name.length > 0) {
              window.localStorage.setItem("t_url", JSON.stringify(t_url));
            }
            attributeModels.push(itemData);
            if (attributeModels.length == data[25].groupValues.length) {
              this.$nextTick(() => {
                this.init3d();
                this.animate();
              });
            }
          });
        });
      }
      this.space = {
        attributeModels: attributeModels,
        max: attribute3d.maxDistance,
        min: attribute3d.minDistance,
        scale: scale,
        scaleLimit: 1,
        modelCenter: this.detail.attribute3d.modelCenter
      };
      this.light = {
        highlight: highlight,
        parallelLight: parallelLight,
        pointLight: PLight,
        envLight: Alight
      };
      this.others = {
        normalMapStrength: normalMapStrength,
        opacity: attribute3d.opacity
      };
    },
    // 3d文物加载
    init3d() {
      let that = this;
      attributeModels.map((a, i) => {
        angleX.push(a.angleX); //x轴
        angleY.push(a.angleY); //y轴
        angleZ.push(a.angleZ); //z轴
        axisX.push(a.axisX); //x轴
        axisY.push(a.axisY); //y轴
        axisZ.push(a.axisZ); //z轴
        model.push(a.modelPath); //文物路径
        modelName.push(a.modelName); //文物名称
        if (a.chartlet) {
          var new_c = a.chartlet.split('|');
          for (var c = 0; c < new_c.length; c++) {
            tex.push(new_c[c]);
          }
          //文物贴图
        }
        if (a.normalPath) {
          var new_n = a.normalPath.split('|');
          for (var c = 0; c < new_n.length; c++) {
            normalPath.push(new_n[c]);
          }
          //文物贴图
        }
        if (a.mtlFile) {
          mtl.push(a.mtlFile); //文物mtl
          index.push(mtl[i].lastIndexOf("\/"));
          // mtlUrl.push(mtl[i].substring(0, index[i] + 1));
          var urlMtl = process.env.NODE_ENV == 'development' ? stageUrl : 'https://museum.chaoxing.com/download/';
          mtlUrl.push(urlMtl);
        }
        if (a.mtlName) {
          mtlName.push(a.mtlName);
        }
      });
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, photonear, photofar);
      camera.position.z = 250;
      group = new THREE.Object3D();
      let detailCode = that.detailCode;
      scene.add(camera);
      if (parallelLight) {
        directionalLight = new THREE.DirectionalLight(0xffffff, parallelLight);
        directionalLight.position.set(0, 0, 250);
        scene.add(directionalLight);
      }
      // 半球光，在场景之上从上到下的光
      ambientLight = new THREE.AmbientLight(0xffffff, Alight);
      scene.add(ambientLight);
      hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, highlight);
      hemiLight.position.set(0, 500, 0);
      scene.add(hemiLight);
      // 四个点光源
      pointLight = new THREE.PointLight(0xffffff, PLight);
      pointLight.position.set(-300, 0, -100);
      scene.add(pointLight);
      pointLight1 = new THREE.PointLight(0xffffff, PLight);
      pointLight1.position.set(100, 0, 300);
      scene.add(pointLight1);
      pointLight2 = new THREE.PointLight(0xffffff, PLight);
      pointLight2.position.set(300, 0, -300);
      scene.add(pointLight2);
      pointLight4 = new THREE.PointLight(0xffffff, PLight);
      pointLight4.position.set(0, -300, 0);
      scene.add(pointLight4);
      manager = new THREE.LoadingManager();

      // manager.onProgress = function (item, loaded, total) {
      //   console.log("走着了么");
      //   console.log(item, loaded, total);
      //   console.log('@@@@@@' + loaded / total);
      //   if (loaded == total) {
      //     console.log('@@@@@@1加进度条');
      //     $(' #loadingdiv ').hide();
      //   }
      // };
      var num = 0;
      var code = this.detail.code;
      //加载进度
      onProgress = function (xhr) {
        if (xhr.lengthComputable) {
          //setInterval(1000);
          var percentComplete = xhr.loaded / xhr.total * 100;
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          if (percentComplete == 100) {
            progressNums.push(100);
          }
          if (percentComplete > 80 && attributeModels.length != 1 && progressNums.length != attributeModels.length) {} else {
            var speed = Math.round(percentComplete, 2);
            percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
            document.getElementById("bar_" + code).style.width = speed + "%";
            document.getElementById("bar_" + code).innerHTML = speed + "%";
            if (document.getElementById('containRelics')) {
              document.getElementById('containRelics').style.visibility = 'hidden';
            }
            if (percentComplete == 100) {
              that.showDebug = true;
              document.getElementById('containRelics').style.visibility = 'visible';
              setTimeout(function () {
                document.getElementById("loadbar_" + code).style.display = 'none';
                document.getElementById("bar_" + code).style.display = 'none';
              }, 1500);
            }
          }
        }
      };
      onOtherProgress = function (xhr) {
        var percentComplete = xhr.loaded / xhr.total * 100;
        if (percentComplete == 100) {
          progressNums.push(100);
        }
        if (progressNums.length == attributeModels.length && percentComplete > 80) {
          var percent = document.getElementById("bar_" + code);
          if (!percent) return;
          var speed = Math.round(percentComplete, 2);
          percent.innerText = Math.round(percentComplete, 2) + '% 已经加载';
          document.getElementById("bar_" + code).style.width = speed + "%";
          document.getElementById("bar_" + code).innerHTML = speed + "%";
          if (percentComplete == 100) {
            that.showDebug = true;
            document.getElementById('containRelics').style.visibility = 'visible';
            setTimeout(function () {
              document.getElementById("loadbar_" + code).style.display = 'none';
              document.getElementById("bar_" + code).style.display = 'none';
            }, 1500);
          }
        }
      };
      renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      renderer.setClearAlpha(0.0);
      renderer.setPixelRatio(window.devicePixelRatio);
      let h = document.documentElement.clientHeight;
      let w = document.documentElement.clientWidth;
      renderer.setSize(w, h);
      document.getElementById('containRelics').appendChild(renderer.domElement);
      // that.canvasMouse()
      controls = new THREE.OrbitControls(camera, renderer.domElement);
      controls.noZoom = true;
      controls.minDistance = 200;
      controls.maxDistance = 2000;
      if (modelName[0].match('.obj') || modelName[0].match('.OBJ')) {
        // 暂时只加载1个mtl
        if (mtlName[0] && mtlName[0].match('.mtl')) {
          that.loadNextMtl(0);
        } else {
          that.loadNextObj(0, detailCode);
        }
      } else {
        fbx = 1;
        //可以在这里更换fbx试试其他效果
        loader.load(model[0], function (object) {
          object.position.set(0, 0, 0);
          object.scale.set(scale, scale, scale);
          ob = object;
          scene.add(object);
          object.children[0].geometry.center();
        });
      }
    },
    createDragControls() {
      return;
      let that = this;
      console.log(camera, renderer);
      var transformControls = new THREE.TransformControls(camera, renderer.domElement);
      scene.add(transformControls);
      // var objects = [];
      // for (let i = 0; i < scene.children.length; i++) {
      //   if (scene.children[i].isMesh) {
      //     objects.push(scene.children[i]);
      //   }
      // }
      objects = objects[0].children;
      console.log(objects, 111);

      // 初始化拖拽控件
      var dragControls = new THREE.DragControls(objects, camera, renderer.domElement);

      // 鼠标略过
      dragControls.addEventListener('hoveron', function (event) {
        for (var i = 0; i < objects.length; i++) {
          objects[i].position.x = event.object.position.x;
          objects[i].position.y = event.object.position.y;
          objects[i].position.z = event.object.position.z;
        }
      });
      // 开始拖拽
      dragControls.addEventListener('dragstart', function (event) {
        controls.enabled = false;
      });
      // 拖拽结束
      dragControls.addEventListener('dragend', function (event) {
        controls.enabled = true;
      });
    },
    clearBeforeModel(type) {
      let that = this;
      // debugger
      if (scene) {
        scene.children.map(child => {
          if (child.type == 'Group' && (child.name != that.detailCode || type == 'load')) {
            child.children.map(function (obj) {
              if (obj.type === 'Mesh') {
                obj.geometry.dispose();
                obj.material.dispose();
              }
            });
            scene.remove(child);
            child = null;
          }
        });
      }
    },
    loadNextMtl(i) {
      let that = this;
      if (i > modelName.length - 1) return;
      var loader = new THREE.TextureLoader();
      loader.setCrossOrigin("Anonymous");
      var mtlLoader = new THREE.MTLLoader();
      mtlLoader.setCrossOrigin("Anonymous");
      mtlLoader.setPath(mtlUrl[i]); // obj mtl文件的目录
      let mtlLoaderName = mtl[i].replace(mtlUrl[i], '');
      mtlLoader.load(mtlLoaderName, function (materials) {
        materials.preload();
        objectModel = new THREE.OBJLoader();
        objectModel.setMaterials(materials);
        // objLoader.setPath(mtlUrl[i]);
        objectModel.load(model[i], function (object) {
          object.scale.x = object.scale.y = object.scale.z = scale;
          object.rotation.set(Math.PI * Number(angleX[i] / 180), Math.PI * Number(angleY[i] / 180), Math.PI * Number(angleZ[i] / 180));
          object.position.set(axisX[i], axisY[i], axisZ[i]);
          object.name = i;
          group.add(object);
          objects.push(object);
        }, i == 0 ? onProgress : onOtherProgress);
      });
      scene.add(group);
      // objects.push(group)
      that.loadNextMtl(i + 1);
    },
    loadNextObj(i, detailCode) {
      let that = this;
      let a = i;
      if (i > modelName.length - 1) return;
      var textureLoader = new THREE.TextureLoader();
      var texture = textureLoader.load(tex[i]);
      texture.minFilter = THREE.NearestFilter;
      var textureNormal;
      if (normalPath.length) {
        var normalImg = normalPath[i];
        textureNormal = textureLoader.load(normalImg);
      }
      var aoTexture;
      var loader = new THREE.OBJLoader(manager);
      loader.load(model[i], function (object) {
        object.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            child.material = new THREE.MeshPhongMaterial({
              map: texture,
              normalMap: textureNormal,
              normalScale: new THREE.Vector2(normalMapStrength, normalMapStrength),
              emissive: texture,
              shininess: 1000,
              needsUpdate: true,
              aoMap: aoTexture,
              aoMapIntensity: 1
            });
          }
        });
        object.children[0].geometry.computeBoundingBox();
        // object.children[0].geometry.center();

        object.scale.x = object.scale.y = object.scale.z = scale;
        object.rotation.set(Math.PI * Number(angleX[a] / 180), Math.PI * Number(angleY[a] / 180), Math.PI * Number(angleZ[a] / 180));
        object.position.set(0, 0, 0);
        object.name = i;
        group.add(object);
        objects.push(object);
        // scene.add(object)
        that.createDragControls();
        that.render();
      }, i == 0 ? onProgress : onOtherProgress);
      scene.add(group);
      console.log(55678);
      that.loadNextObj(i + 1, detailCode);
    },
    // 图片文物类型加载
    initImage() {
      this.$nextTick(() => {
        this.swiperElImg = new Swiper(this.$refs.swiperImg, {
          navigation: {
            nextEl: ".next",
            prevEl: ".prev"
          },
          slidesPerView: 'auto',
          initialSlide: 0,
          centeredSlides: true,
          runCallbacksOnInit: false,
          touchMoveStopPropagation: true,
          slideToClickedSlide: true,
          observer: true,
          observeSlideChildren: true
        });
      });
    },
    // 360文物加载
    init360(data) {
      let images = data['360'].groupValues[0].values[0];
      images = images.map(item => {
        return process.env.NODE_ENV == 'development' ? stageUrl + '360/' + item.name : item.fileUrl ? item.fileUrl.replace('http:', 'https:') : '';
      });
      this.detail.images360 = images;
      this.options.source = images;
      this.$nextTick(() => {
        // setTimeout(() => {
        loadImage();
        // }, 1000)
      });
    },
    animate() {
      requestAnimationFrame(this.animate);
      if (controls) {
        // orbitControls.update();
        controls.update();
        this.render();
      } else {
        cancelAnimationFrame(this.animate);
      }
    },
    render() {
      renderer.render(scene, camera);
    },
    // 文物清空
    clearScene(type, codeIndex) {
      angleX = [];
      angleY = [];
      angleZ = [];
      axisX = [];
      axisY = [];
      axisZ = [];
      tex = [];
      model = [];
      modelName = [];
      mtl = [];
      index2 = [];
      index = [];
      mtlUrl = [];
      mtlName = [];
      normalPath = [];
      attributeModels = [];
      if (scene) {
        scene.traverse(child => {
          if (child.material) {
            child.material.dispose();
          }
          if (child.geometry) {
            child.geometry.dispose();
          }
          child = null;
        });
      }
      if (renderer) {
        renderer.forceContextLoss();
        renderer.dispose();
        renderer.domElement = null;
      }
      controls = null;
      scene = null;
      camera = null;
      renderer = null;
      document.getElementById('containRelics').innerHTML = '';
      cancelAnimationFrame(this.animate);
      if (type == 'changeColumn') return;
      this.$nextTick(() => {
        this.getDetailByCode();
      });
    },
    getValInFormData(data, id, type, index) {
      index = index || 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? stageUrl + data[id].groupValues[index].values[0][0].name : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : target;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    // 切换底部文物
    slideFun(e) {
      console.log(this.listPage, this.listTotal);
      if (this.listPage < this.listTotal) {
        if ((this.swiperEl.realIndex + 1) % 10 == 0 || this.swiperEl.realIndex + 1 > 10 * (this.listPage - 1) || this.swiperEl.realIndex == this.list.length) {
          this.listPage++;
          this.getList();
        }
      }
    },
    clickDetail(index) {
      this.$router.replace(`/debug?fid=${this.$route.query.fid}&code=${this.list[index].code}`);
      // this.showDebug = false
      // this.detailCode = this.list[index].code
      // this.showBigErCode = false
      // this.showModels = [false, false, false]
      // // 动态加载数据
      // this.getDetailByCode()
    },
    // 获取底部文物信息列表
    getList(type) {
      let query = {
        deptId: this.$route.query.fid,
        formId: 113010,
        page: this.listPage,
        limit: 10,
        searchStr: ''
      };
      let a = {
        filters: [[{
          alias: "type",
          compt: "selectbox",
          express: "match",
          id: 29,
          range: null,
          val: ['3D']
        }]],
        model: 0
      };
      // return console.log(a)
      query.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(query).then(res => {
        this.listTotal = res.totalPage;
        this.setListData(res.dataList, type);
      });
    },
    // 底部文物信息列表数据解析
    setListData(data, type) {
      let list = data.map(item => {
        let nItem = {
          columnName: this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
          code: this.getValInFormData(item.formIdValueData, 'autoId'),
          type: this.getValInFormData(item.formIdValueData, 'type')
        };
        return nItem;
      });
      this.listPage > 1 ? list = list.filter(l => {
        return l.code != this.list[0].code;
      }) : '';
      this.list = this.list.concat(list);
      let that = this;
      if (this.listPage == 1) {
        this.$nextTick(() => {
          this.swiperEl = new Swiper(this.$refs.swipercontainer, {
            navigation: {
              nextEl: ".btnTurnRight",
              prevEl: ".btnTurnLeft"
            },
            slidesPerView: 'auto',
            initialSlide: 0,
            centeredSlides: true,
            runCallbacksOnInit: false,
            touchMoveStopPropagation: true,
            slideToClickedSlide: true,
            observer: true,
            observeSlideChildren: true
          });
          let that = this;
          this.swiperEl.on('slideChangeTransitionEnd', function (e) {
            that.slideFun(e);
          });
        });
        if (!this.$route.query.code) {
          this.detailCode = this.list[0].code;
        }
        this.activeIndex = this.list.findIndex(item => {
          return item.code == this.detailCode;
        });
        if (this.activeIndex == 0) return this.getDetailByCode();
        if (this.activeIndex == -1) return this.getDetailByCode(false, 'addActiveItem');
        this.$nextTick(() => {
          this.swiperEl.slideTo(this.activeIndex);
          this.getDetailByCode();
        });
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid;
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          logo: this.getConfigInFormData(data.formData, 4, 'img')
        };
        // this.getList()
        this.getColumn();
      });
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }) ? data.find(d => {
        return d.alias == id;
      }).values[0] : '';
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? this.stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    }
  },
  created() {
    let list = ['OBJLoader.js', 'FBXLoader.js', 'inflate.min.js', 'TGALoader.js', 'TrackballControls.js', 'PDBLoader.js', 'CSS2DRenderer.js', 'FBXLoader.js', 'MTLLoader.js', 'Detector.js', 'OrbitControls.js', 'DragControls.js', 'TransformControls.js'];
    list.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/3d/${item}`;
      document.body.appendChild(oScript);
    });
    let list2 = ['jquery-1.11.0.min.js', 'heartcode-canvasloader-min.js', 'threesixty.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  mounted() {
    this.detailCode = this.$route.query.code;
    this.getDetailByCode();
    this.getConfig();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  },
  watch: {
    '$route'(to, from) {
      location.reload();
    }
  }
};